var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E7F90700-77D2-4B6B-9877-277838CA4786") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Option-1---Step-2",
    transform: "translate(-598.000000, -899.000000)",
    fill: "#0B7BFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-molecules/sub-question/labelled",
    transform: "translate(257.000000, 818.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-molecules/dropdown/m-fields/empty",
    transform: "translate(24.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Dropdown/Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown-icn-blue",
    transform: "translate(316.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.14792125,3.65474176 L10.3078952,-2.35681343 C10.5051236,-2.54772886 10.8240163,-2.54772886 11.0212447,-2.35681343 L11.8520787,-1.55257276 C12.0493071,-1.36165733 12.0493071,-1.05297172 11.8520787,-0.862056287 L6.87961358,4 L11.8520787,8.86205629 C12.0493071,9.05297172 12.0493071,9.36165733 11.8520787,9.55257276 L11.0212447,10.3568134 C10.8240163,10.5477289 10.5051236,10.5477289 10.3078952,10.3568134 L4.14792125,4.34525824 C3.95069292,4.15434281 3.95069292,3.84565719 4.14792125,3.65474176 Z",
    id: "down-arrow-icn-blue",
    transform: "translate(8.000000, 4.000000) rotate(-90.000000) translate(-8.000000, -4.000000) "
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.b30b0900ba32dd4b3cc4bacafd1ff086.svg";
export { ForwardRef as ReactComponent };